angular.module('unica_hotel.hotel_services', []);